/**
 * Page d'authentification unifiée (login/register)
 * Utilise les modules modulaires register.js et login.js
 */

import { initLoginForm, initModeSwitch, initRegistrationForm, initFormValidation, AUTH_CONFIG } from './pages/auth/index.js';
import { initUsernameGenerator } from './components/username-generator.js';
import { initAuthFingerprinting } from './utils/auth-fingerprint-integration.js';

// Configuration pour l'authentification standard
const authConfig = {
    // Config pour registration
    registration: {
        formId: 'register-form',
        submitBtnId: 'register-submit',
        errorDivId: 'register-error',
        apiEndpoint: AUTH_CONFIG.API.REGISTER, // Utilise la config globale
        redirectType: 'REGISTER',
        defaultRedirect: 'index.php?page=jeu',
        analyticsPrefix: 'REGISTRATION',
        requireUsername: true
    },
    // Config pour login
    login: {
        formId: 'login-form',
        submitBtnId: 'login-submit',
        errorDivId: 'login-error',
        apiEndpoint: AUTH_CONFIG.API.LOGIN, // Utilise la config globale
        redirectType: 'LOGIN',
        defaultRedirect: 'index.php?page=jeu',
        analyticsPrefix: 'LOGIN'
    }
};


// Initialisation au chargement de la page
function initAuthPage() {
    // Initialiser tous les composants
    initModeSwitch(); // Gestion login/register toggle
    initLoginForm(authConfig.login);
    initFormValidation(); // Inclut village selection
    initRegistrationForm(authConfig.registration);
    initUsernameGenerator(); // Générateur de pseudonyme pour nouvelles inscriptions
    initAuthFingerprinting(); // Tracking de rétention via browser fingerprint
}

// Auto-init si pas utilisé comme module
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAuthPage);
} else {
    initAuthPage();
}